import { initializeApplication } from "@hireroo/initializer/app";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import Maintenance from "./Maintenance";

const main = async () => {
  if (import.meta.env.VITE_ENABLED_MAINTENANCE_MODE === "true") {
    await initializeApplication({ isMaintenance: true });
    ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<Maintenance />);
    return;
  }

  await initializeApplication({ isMaintenance: false });
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);
};

main().catch(error => {
  console.error(error);
});
